import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  z-index: 2000;
  background: rgba(0,0,0,0.35);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalWindow = styled.div`
  background: ${({ theme }) => theme.card.background};
  border-radius: 20px;
  padding: 36px 28px 24px 28px;
  min-width: 320px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.18);
  text-align: center;
  max-width: 90vw;
`;

const ModalTitle = styled.div`
  font-weight: 700;
  font-size: 22px;
  margin-bottom: 14px;
  color: #ff4444;
`;

const ModalDesc = styled.div`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 16px;
  margin-bottom: 28px;
`;

const ModalButtons = styled.div`
  display: flex;
  gap: 14px;
  justify-content: center;
  margin-bottom: 18px;
`;

const ModalButton = styled.button`
  flex: 1;
  background: ${({ primary }) => (primary ? '#007AFF' : '#fff')};
  color: ${({ primary }) => (primary ? '#fff' : '#007AFF')};
  border: ${({ primary }) => (primary ? 'none' : '1.5px solid #007AFF')};
  border-radius: 10px;
  padding: 12px 0;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
  &:hover {
    background: ${({ primary }) => (primary ? '#0056b3' : '#f0f4ff')};
    color: ${({ primary }) => (primary ? '#fff' : '#0056b3')};
  }
`;

const ModalClose = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.text.secondary};
  font-size: 15px;
  cursor: pointer;
  margin-top: 2px;
  opacity: 0.7;
  &:hover {
    opacity: 1;
    text-decoration: underline;
  }
`;

const NoTokensModal = ({
  isOpen,
  onClose,
  onBuy,
  onInvite,
  title,
  desc,
  buyLabel,
  inviteLabel,
  closeLabel
}) => {
  if (!isOpen) return null;
  return (
    <ModalOverlay>
      <ModalWindow>
        <ModalTitle>{title}</ModalTitle>
        <ModalDesc>{desc}</ModalDesc>
        <ModalButtons>
          <ModalButton primary onClick={onBuy}>{buyLabel}</ModalButton>
          <ModalButton onClick={onInvite}>{inviteLabel}</ModalButton>
        </ModalButtons>
        <ModalClose onClick={onClose}>{closeLabel}</ModalClose>
      </ModalWindow>
    </ModalOverlay>
  );
};

export default NoTokensModal; 